import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=fb1f4bf0&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./notice.vue?vue&type=style&index=1&id=fb1f4bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1f4bf0",
  null
  
)

export default component.exports